import { htmlLanguage } from '@codemirror/lang-html';

const TEMPLATE_COMPLETION_REGEX = /{\\?if[a-z_]*/;
const TEMPLATE_BLOCK_REGEX = /^{\\?if[a-z_]*}$/;

let options = [];

const templateCompletions = (context) => {
  const before = context.matchBefore(TEMPLATE_COMPLETION_REGEX);

  if (!context.explicit && !before) {
    return null;
  }

  return {
    from: before ? before.from : context.pos,
    to: context.pos + 1,
    options,
    validFor: TEMPLATE_BLOCK_REGEX
  };
};

export const opensenseTemplateAutocomplete = (additionalOptions) => {
  if (additionalOptions) {
    options = [
      ...additionalOptions
        .map(({ name }) => [
          {
            label: `{if_${name}}`,
            type: 'keyword'
          },
          {
            label: `{/if_${name}}`,
            type: 'keyword'
          }
        ])
        .flat()
    ];
  }

  return htmlLanguage.data.of({
    autocomplete: templateCompletions
  });
};
